<template>
  <div class="ability-chart">
    <div class="flex flex-between my-3">
      <div class="flex-left">
        <h4 class="page-title">{{ courseInfo.index_name }}</h4>
      </div>
      <div class="flex-right">
        <el-radio-group v-model="radio" size="small" @change="handleChangeRadio">
          <el-radio-button :label="item.label" v-for="item in radioList" :key="item.id">{{
            item.name
          }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <router-view
      :key="$route.fullPath"
      :courseInfo="courseInfo"
      :update-priv="updatePriv"
      :priv-checked="privChecked"
    ></router-view>
  </div>
</template>
<script>
export default {
  name: 'AbilityChart',
  data() {
    return {
      courseInfo: {
        last_update_time: '',
        start_time: '',
        end_time: '',
        fullname: '',
      },
      updatePriv: false, // 当前用户是否有该课程的图谱配置权限
      privChecked: false, // 权限接口是否已返回
      radio: '',
      radioList: [
        {
          id: 1,
          name: '图谱概况',
          label: 'abilityBaseInfo',
        },
        {
          id: 2,
          name: '配置图谱',
          label: 'abilityConfigure',
        },
        {
          id: 3,
          name: '查看能力达成',
          label: 'abilityAchieve',
        },
      ],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.commom?.userInfo
    },
  },
  watch: {
    $route: {
      handler() {
        // console.log('route', this.$route)

        this.radio = this.$route.name || this.radioList[0].label

        if ([6, 7].includes(this.userInfo?.role_id)) {
          this.radioList = [
            {
              id: 1,
              name: '图谱概况',
              label: 'abilityBaseInfo',
            },
            {
              id: 3,
              name: '查看能力达成',
              label: 'myAchieve',
            },
          ]
        } else if (this.$route.query.userId && this.$route.name === 'myAchieve') {
          this.radio = 'abilityAchieve'
        }
        this.initPage()
      },
      immediate: true,
    },
  },
  methods: {
    // 初始化页面：配置图谱页需要先校验权限，再获取课程详情
    async initPage() {
      this.updatePriv = false
      this.privChecked = false
      if (this.$route.path === '/ability-graph/detail/configure') {
        await this.checkUpdatePriv()
      }
      this.getCourseDetailApi()
    },
    // 校验当前用户是否有该课程的图谱配置权限
    checkUpdatePriv() {
      return this.$store
        .dispatch('capability/getCapabilityUpdatePriv', { course_id: this.$route.query.courseId })
        .then((res) => {
          this.updatePriv = res.code === 1 && !!res.data?.update_priv
        })
        .catch((err) => {
          this.updatePriv = false
        })
        .finally(() => {
          this.privChecked = true
        })
    },
    // 获取课程详情接口
    async getCourseDetailApi() {
      await this.$store
        .dispatch('capability/getCapabilityCourseDetail', {
          course_id: Number(this.$route.query.courseId),
        })
        .then((res) => {
          if (res.code === 1) {
            this.courseInfo = res.data
            if (this.courseInfo.end_time !== '') {
              this.courseInfo['courseTime'] = `${this.courseInfo.start_time?.replace(/-/g, '.')} 至
                  ${this.courseInfo.end_time?.replace(/-/g, '.')}`
            } else {
              this.courseInfo['courseTime'] = `${this.courseInfo.start_time?.replace(/-/g, '.')} 起`
            }
            this.$store.commit('course/setCourseInfo', this.courseInfo)
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    handleChangeRadio() {
      console.log(this.radio)
      if(this.$route.query.userId) {
        delete this.$route.query.userId
      }
      this.$router.push({
        name: this.radio,
        query: this.$route.query,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-chart {
  .page-title {
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
